import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import Page from 'modules/app/components/Page';
import Skeleton from 'components/shared/Skeleton';
import PageContainer from 'components/shared/PageContainer';
import { ReactComponent as IconSearch } from 'images/search.svg';
import { ReactComponent as IconClear } from 'images/icons/search/clear.svg';
import clsx from 'clsx';
import NoContent from 'components/shared/NoContent/NoContent';
import Input from 'components/shared/Input';
import Button from 'components/shared/Button';
import useTopics from 'sdk/hooks/discovery/useTopics';
import styles from './Topics.module.scss';

function TopicsSkeleton() {
  return (
    <PageContainer className={styles.container}>
      <div className={styles.headerRow}>
        <Link className={styles.h} to="/">
          <div className={styles.title}>
            <IconArrowRight />
            Topics
          </div>
        </Link>
      </div>
      <div className={styles.topics}>
        {Array.from(Array(10).keys()).map((item: number) => (
          <Skeleton
            key={item}
            className={styles.topicsItem}
          />
        ))}
      </div>
    </PageContainer>
  )
}

function Topics() {
  const [search, setSearch] = useState('')
  const [openSearch, setOpenSearch] = useState<boolean>(false)
  const {
    data, isLoading,
    isSuccess,
  } = useTopics(search)

  const [topics, setTopics] = useState(data)
  const [loaded, setLoaded] = useState<boolean>(false);

  const navigate = useNavigate()

  const handleSearchChange = (e: React.FormEvent<HTMLInputElement>) => {
    setSearch((e.target as HTMLInputElement).value)
  }

  useEffect(() => {
    if (isSuccess) {
      setLoaded(true)
      setTopics(data?.map((item) => {
        const copy = item
        return copy
      }))
    }
  }, [isSuccess, data])

  if (isLoading && !loaded) {
    return (<TopicsSkeleton />)
  }

  return (
    <PageContainer className={styles.container}>
      <div className={styles.headerRow}>
        <div
          className={clsx(
            styles.h,
            openSearch && styles.h_search,
          )}
          onClick={() => navigate(-1)}
        >
          <h1 className={styles.title}>
            <IconArrowRight />
            Topics
          </h1>
        </div>
        <Button
          className={styles.searchBtn}
          onClick={() => setOpenSearch(true)}
          iconBtn
        >
          <IconSearch />
        </Button>
        { openSearch && (
          <Input
            icon={<IconSearch className={styles.prefix} />}
            suffix={<IconClear className={styles.suffix} onClick={() => setOpenSearch(false)} />}
            className={styles.searchInput}
            value={search}
            onChange={handleSearchChange}
            placeholder="Search on Beautify"
          />
        )}
      </div>
      {topics?.length ? (
        <div className={clsx(
          styles.topics,
          isLoading && styles.topics_loading,
        )}
        >
          {topics?.map((topic: any) => (
            <div className={styles.topicsItem} key={topic?.playlistId}>
              <div className={styles.nameBlock}>
                <span className={styles.nameBlockIcon}>
                  {
                  topic.image ? <img src={topic.image} alt={topic.name} />
                    : '#'
                }
                </span>
                <span className={styles.name}>{topic.name}</span>
              </div>
              <div className={styles.countBlock}>
                <span className={styles.count}>0</span>
                <span className={styles.countCaption}>Publications</span>
              </div>
              <div className={styles.arrowButton}>
                <IconArrowRight />
              </div>
              <Link className={styles.link} to={`/playlist/${topic?.playlistId}`} />
            </div>
          ))}
        </div>
      ) : null}
      {!topics?.length && (
        <div className={isLoading ? styles.topics_loading : ''}>
          <NoContent
            message="No data satisfying the filters"
          />
        </div>
      )}
    </PageContainer>
  )
}

function TopicsPage() {
  return (
    <Page activeLink="/">
      <Topics />
    </Page>
  )
}

export default TopicsPage
